import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ClientsService } from '../../../../services/clients.service';
import { PetsService } from '../../../../services/pets';

@Component({
  selector: 'app-createpet',
  templateUrl: './createpet.component.html',
  styleUrl: './createpet.component.scss',
})
export class CreatepetComponent implements OnInit {
  petForm!: FormGroup;
  clients: any[] = [];
  contentReady = false;
  saving = false;
  submitted = false;
  warehouseId = Number(localStorage.getItem('posId'));
  isAr = localStorage.getItem('language') === 'ar';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private clientsService: ClientsService,
    private petsService: PetsService
  ) {}

  ngOnInit(): void {
    this.petForm = this.fb.group({
      client_id: ['', Validators.required],
      pet_type: ['', Validators.required],
      name: ['', Validators.required],
      breed: [''],
      color: [''],
      special_markings: [''],
      date_of_birth: [''],
      gender: ['male'],
      spayed_neutered: [false],
    });

    this.loadClients();
  }

  loadClients(): void {
    if (!this.warehouseId) return;

    this.contentReady = true;
    this.clientsService.getClients(500, 1, this.warehouseId).subscribe({
      next: (res: any) => {
        this.clients = res?.clients?.data || res?.data || res?.clients || [];
        this.contentReady = false;
      },
      error: (err) => {
        console.error(err);
        this.contentReady = false;
      },
    });
  }

  savePet(): void {
    this.submitted = true;

    if (this.petForm.invalid || this.saving) {
      this.petForm.markAllAsTouched();
      return;
    }

    this.saving = true;
    const payload = {
      ...this.petForm.value,
      warehouse_id: this.warehouseId,
    };

    this.petsService.createPet(payload).subscribe({
      next: () => {
        this.saving = false;
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'تم إنشاء الحيوان بنجاح' : 'Pet created successfully',
        });
        this.router.navigate(['/pets']);
      },
      error: (err) => {
        console.error(err);
        this.saving = false;
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'تعذر إنشاء الحيوان' : 'Failed to create pet',
        });
      },
    });
  }

  resetForm(): void {
    this.submitted = false;
    this.petForm.reset({
      client_id: '',
      pet_type: '',
      name: '',
      breed: '',
      color: '',
      special_markings: '',
      date_of_birth: '',
      gender: 'male',
      spayed_neutered: false,
    });
  }

  shouldShowError(controlName: string): boolean {
    const control = this.petForm?.get(controlName);
    return !!control && control.invalid && (control.touched || this.submitted);
  }

  getClientLabel(client: any): string {
    const name = client?.client_name || client?.name || '-';
    const phone = client?.phone_number || client?.phone || '';

    return phone ? `${name} - ${phone}` : name;
  }
}
